import React, { Component } from "react";
import { connect } from "react-redux";
import EditActions from "../schema/misc/EditActions";
import CenteredPaper from "../layouts/CenteredPaper";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import { IrqTitle } from "../molecules/IrqTitle";
import { MoneyInput } from "../atoms/MoneyInput";
import ILearn from "../molecules/ILearn";

class REFINANCEIRQHowMuchCashOutView extends Component {
  render() {
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle content={this.props.content} />
          <div className="money-input-wrapper">
            <MoneyInput
              name="amountOfCashOut"
              error={!!this.props.errors.amountOfCashOut}
              value={this.props.values.amountOfCashOut || ""}
              onChange={this.props.onFormEdit}
              onBlur={this.props.onBlur}
            />
          </div>
          <EditActions canSubmit={this.props.isValid} />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(REFINANCEIRQHowMuchCashOutView));
